import { formStyles } from '../ui/formStyles';

interface ProductSaveBarProps {
  name: string;
  onNameChange: (value: string) => void;
  onSave: () => void;
  placeholder?: string;
  saving?: boolean;
  saveLabel?: string;
}

// Name input + Save button rendered in a product detail page's PageHeader
// actions slot. Single source of truth for the "rename + save" UX across
// IR Swap, CDS, Inflation Swap, Swaption, Equity Option and Bond pages.
export default function ProductSaveBar({
  name,
  onNameChange,
  onSave,
  placeholder = 'Name this product…',
  saving = false,
  saveLabel = 'Save',
}: ProductSaveBarProps) {
  return (
    <div className="flex items-center gap-2">
      <input
        type="text"
        value={name}
        onChange={e => onNameChange(e.target.value)}
        placeholder={placeholder}
        className={`${formStyles.input} min-w-[220px]`}
        aria-label="Product name"
      />
      <button
        type="button"
        onClick={onSave}
        disabled={saving}
        className={`${formStyles.primaryButton} disabled:opacity-50`}
      >
        {saving ? 'Saving…' : saveLabel}
      </button>
    </div>
  );
}
